export default {
  // 开发
  develop: 'http://www.youkehulian.cn/',
  // 正式
  product: 'http://www.youkehulian.com/',

  // local: 'http://192.168.31.169:8001/',
  // 线上测试

  // local: 'http://192.168.31.167:8001/',
  local: 'http://www.youkehulian.cn/',

  //local: 'http://106.15.89.121:8080/',
  // 阿里对象存储
  alioss: 'http://106.14.219.98:3000/',
}
